import { useEffect, useState } from "react";
import api from "../lib/api";

// Renders an authenticated image (or fallback) by fetching as blob with bearer token.
export default function AuthImage({ path, alt = "", className = "", fallback }) {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        let revoke = null;
        let aborted = false;
        async function load() {
            if (!path) { setSrc(null); return; }
            try {
                const r = await api.get(`/files/${path}`, { responseType: "blob" });
                if (aborted) return;
                const url = URL.createObjectURL(r.data);
                revoke = url;
                setSrc(url);
            } catch {
                if (!aborted) setSrc(null);
            }
        }
        load();
        return () => { aborted = true; if (revoke) URL.revokeObjectURL(revoke); };
    }, [path]);

    if (!path || !src) {
        return (
            <div className={`bg-zinc-100 ${className} flex items-center justify-center`}>
                {fallback || <span className="text-[10px] uppercase tracking-widest text-zinc-400">Dermalis</span>}
            </div>
        );
    }
    return <img src={src} alt={alt} className={className} />;
}
